module.exports = __webpack_public_path__ + "img/pinduoduo-propa.d61c2675.png";